import React from 'react'

function StoreSettings() {
    return (
        <div>StoreSettings</div>
    )
}

export default StoreSettings